import StepperBase from '../StepperBase'
import {ImportButton} from '../../1elements'

const BulkImportStepper = ({stepHeadings, getStepContent, handleImportButton, disabled, customFirstButton,setTemplate}) => {
    const finalAction = (<ImportButton onClick={handleImportButton} />)

    return (
        <StepperBase steps={stepHeadings} getStepContent={getStepContent}
                     finalAction={finalAction} orientation={'vertical'}
                     disabled={disabled} customFirstButton={customFirstButton} setTemplate ={setTemplate} isImport = {true}/>
    )
}

export default BulkImportStepper